
'use strict';

const _config = {
    searchFormObj: '',
    advSearchFormObj: '',
    gridBaseURL: '',
    gridEditURL: '',
    gridSelector: '',
};

let nominalCodes = '';

export function init(options) {
    if (!options) {
        options = {};
    }

    if (!options.gridSelector || !options.gridBaseURL
            || !options.gridEditURL || !options.searchFormObj){
        console.log('Missing Grid Options for Contract Account Review Grid');
        var alertBody = 'Unable to update grid. Please reload and try again';
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: alertBody});
        return false;
    };

    _config.gridSelector = options.gridSelector;
    _config.gridBaseURL = options.gridBaseURL;
    _config.gridEditURL = options.gridEditURL;
    _config.searchFormObj = options.searchFormObj;

    $('.jq_button').button();
}

export function loadContractAccountReviewGrid({ nominals } = {}){
    if (!_config.gridSelector || !_config.gridBaseURL){
        console.log('Missing Grid Options for Contract Account Review Grid');
        var alertBody = 'Unable to update grid. Please reload and try again';
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: alertBody});
        return false;
    };

    // Convert the external JS object into a format jqGrid can use (key:value)
    var gridDropdown = '';
    for (var key in nominals) {
        if (nominals.hasOwnProperty(key)) {
            gridDropdown += key + ':' + nominals[key] + ';';
        }
    }

    // Remove the last semicolon
    gridDropdown = gridDropdown.slice(0, -1);

    _config.gridSelector.jqGrid({
        url: _config.gridBaseURL,
        datatype: 'json',
        colNames: [
            'ID'
            ,'APPSNOMSTYPE'
            ,'Season'
            ,'Stallion'
            ,'No.'
            ,'Purchaser'
            ,'MareID'
            ,'Mare'
            ,'Status'
            ,'Fee'
            ,'Type'
            ,'Terms'
            ,'CONTRACTBILLED'
            ,'Billed'
            ,'CONTRACTPAID'
            ,'Paid'
            ,'BARREN'
            ,'Barren'
            ,'PurchaserHTML'
            ,'Location'
            ,'Product',
        ],
        colModel: [
            {name: 'ID'
                ,index: 'ID'
                ,width: 0
                ,sorttype: 'int'
                ,editable: false
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'APPSNOMSTYPE'
                ,index: 'APPSNOMSTYPE'
                ,width: 0
                ,sorttype: 'int'
                ,editable: false,
                hidden: true,
                hidedlg: true}
            ,{name: 'SEASON'
                ,index: 'SEASON'
                ,width: 5
                ,sorttype: 'int'
                ,editable: false
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'STALLIONNAME'
                ,index: 'STALLIONNAME'
                ,width: 18
                ,sorttype: 'text'
                ,editable: false
                ,classes: 'nowrap pointer'
                ,hidden: true}
            ,{name: 'NOMINATIONNUMBER'
                ,index: 'NOMINATIONNUMBER'
                ,width: 3
                ,sorttype: 'text'
                ,editable: false
                ,classes: 'pointer'
                ,align: 'right'}
            ,{name: 'Purchaser'
                ,index: 'Purchaser'
                ,width: 20
                ,editable: false
                ,classes: 'pointer relative-cell'}
            ,{name: 'MAREID'
                ,index: 'MAREID'
                ,width: 0
                ,sorttype: 'int'
                ,editable: false
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'MARENAME'
                ,index: 'MARENAME'
                ,width: 15
                ,editable: false
                ,classes: 'pointer'}
            ,{name: 'APPNOMSTATUS'
                ,index: 'APPNOMSTATUS'
                ,width: 8
                ,editable: false
                ,classes: 'pointer'
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'FEETOTAL'
                ,index: 'FEETOTAL'
                ,width: 10
                ,editable: false
                ,classes: 'pointer'
                ,sorttype: 'float'
                ,align: 'right'
                ,formatter: 'number'
                ,editoptions: {decimalPlaces: '2'}}
            ,{name: 'APPSNOMSCONTRACTTYPE'
                ,index: 'APPSNOMSCONTRACTTYPE'
                ,width: 6
                ,editable: false
                ,classes: 'pointer'}
            ,{name: 'APPNOMTERM'
                ,index: 'APPNOMTERM'
                ,width: 8
                ,editable: false
                ,classes: 'pointer'
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'CONTRACTBILLED'
                ,index: 'CONTRACTBILLED'
                ,width: 5
                ,editable: false
                ,classes: 'pointer'
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'BILLED'
                ,index: 'BILLED'
                ,width: 6
                ,editable: false
                ,classes: 'pointer'
                ,sorttype: 'int'
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'CONTRACTPAID'
                ,index: 'CONTRACTPAID'
                ,width: 5
                ,editable: false
                ,classes: 'pointer'
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'PAID'
                ,index: 'PAID'
                ,width: 5
                ,editable: false
                ,classes: 'pointer'
                ,sorttype: 'int'
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'BARREN'
                ,index: 'BARREN'
                ,width: 5
                ,editable: false
                ,classes: 'pointer'
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'BARRENCERT'
                ,index: 'BARRENCERT'
                ,width: 8
                ,editable: false
                ,classes: 'pointer'
                ,sorttype: 'int'
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'PURCHASERHTML'
                ,index: 'PURCHASERHTML'
                ,width: 0
                ,sorttype: 'int'
                ,editable: false
                ,hidden: true
                ,hidedlg: true}
            ,{name: 'LOCATION'
                ,index: 'LOCATION'
                ,width: 20
                ,editable: true
                ,edittype: 'select'
                ,formatter: 'select'
                ,cellEdit: true
                ,editoptions: {value: gridDropdown}
                ,classes: 'pointer'}
            ,{name: 'PRODUCT'
                ,index: 'PRODUCT'
                ,width: 20
                ,editable: true
                ,edittype: 'select'
                ,formatter: 'select'
                ,cellEdit: true
                ,editoptions: {value: gridDropdown}
                ,classes: 'pointer'},

        ],
        rowNum: 500,
        autowidth: true,
        height: 400,
        sortname: 'STALLIONNAME',
        viewrecords: true,
        sortorder: 'asc',
        loadComplete: function(data){

            //Process Displayed Rows
            var ids = $(this).jqGrid('getDataIDs'), l = ids.length, i, rowid, status;
            for (i = 0; i < l; i++) {
                rowid = ids[i];

                //Disable editing for Billed contracts
                var billed = $(this).jqGrid('getCell', rowid, 'CONTRACTBILLED');
                if (billed.length === 0) {
                    _config.gridSelector.jqGrid('editRow', rowid, false);
                }

                //Purchaser Add Tooltip
                var purchaserCell = _config.gridSelector.jqGrid('getCell', rowid, 'Purchaser');
                if (purchaserCell.length > 0){
                    const purchaserName = purchaserCell;
                    purchaserCell = '<div class="purchaserCell">';
                    purchaserCell += '<span class="purchaserName">' + purchaserName + '</span>';
                    purchaserCell += ' <span data-contractID="' + rowid;
                    purchaserCell += '" class="btn btn_info tooltip right question"></span>';
                    purchaserCell += '</div>';
                }
                _config.gridSelector.jqGrid('setCell', rowid, 'Purchaser', purchaserCell);

                //Unregistered Mare - Add Class to cell
                var mareID = _config.gridSelector.jqGrid('getCell', rowid, 'MAREID');
                if (mareID == ''){
                    _config.gridSelector.jqGrid('setCell',rowid,'MARENAME', '', 'unregisteredMare');
                }

            }

            //Bindings
            bindToolTip();

        },
        hoverrows: true,
        gridComplete: function(){},
        onSelectRow: function(rowid,status,e){},
        loadBeforeSend: function (xhr, settings) {
            this.p.loadBeforeSend = null; //remove event handler
            return false; // dont send load data request
        },

    });
}

function bindToolTip(){

    _config.gridSelector.find('.tooltip').unbind();

    _config.gridSelector.find('.tooltip').bind('click',(event) =>{
        event.preventDefault();
    });

    _config.gridSelector.find('.tooltip').bind('mouseover',function(event){
        event.preventDefault();
        var purchaserHTML = _config.gridSelector.jqGrid('getCell',
            $(this).attr('data-contractID'), 'PURCHASERHTML');
        simpleTooltip.show(purchaserHTML);
    });

    _config.gridSelector.find('.tooltip').bind('mouseout',(event) =>{
        event.preventDefault();
        simpleTooltip.hide();
    });

}

export function refreshContractReviewGrid(){

    if (!_config.gridSelector || !_config.gridBaseURL
        || !_config.gridEditURL || !_config.searchFormObj){
        console.log('Missing Grid Options for Contract Account Review Grid');
        var alertBody = 'Unable to update grid. Please reload and try again';
        EQLAPP.STRIPE.showAlert({title: 'Alert', body: alertBody});
        return false;
    };

    //Build Search URL
    var searchURL = jQuery.param.querystring(_config.gridBaseURL,{
        stallionID: _config.searchFormObj.find("[name='stallionID']").val()
        ,season: _config.searchFormObj.find("[name='season']").val()
        ,Hemisphere: _config.searchFormObj.find("[name='hemisphere']").val()
        ,mareStatusID: _config.searchFormObj.find("[name='mareStatusID']").val()
        ,purchaserID: _config.searchFormObj.find("[name='Purchaser_ID']").val()
        ,mareName: _config.searchFormObj.find("[name='MareName']").val()
        ,statusID: _config.searchFormObj.find("[name='status_id']").val()
        ,termsID: _config.searchFormObj.find("[name='terms_id']").val()
        ,typeID: _config.searchFormObj.find("[name='type_id']").val()
        ,stallionStatusID: 1,
    });

    //Reload grid with search URL
    _config.gridSelector.jqGrid('setGridParam',{url: searchURL,editurl: _config.gridEditURL,page:1})
        .trigger('reloadGrid');

}

//Function used to clear the advanced filters and retrigger grid refresh
export function clearContractReviewAdvancedFilters(){
    //$('#appsNomsAdvancedSearch').reset();
    _config.searchFormObj.find("[name='purchaser_name']").val('All');
    _config.searchFormObj.find("[name='Purchaser_ID']").val('');
    _config.searchFormObj.find("[name='status_name']").val('All');
    _config.searchFormObj.find("[name='status_id']").val('');
    _config.searchFormObj.find("[name='terms_name']").val('All');
    _config.searchFormObj.find("[name='terms_id']").val('');
    _config.searchFormObj.find("[name='type_name']").val('All');
    _config.searchFormObj.find("[name='type_id']").val('');
    $('.advanced_search .btn_clear').addClass('ui-state-disabled');
    refreshContractReviewGrid();
}